<template>
  <v-col
    :class="classes"
    :cols="cols"
    :lg="lg"
    :md="md"
    :sm="sm"
  >
    <v-row dense>
      <template v-if="message">
        <v-col
          :class="labelClass"
          :cols="removable ? '8' : '12'"
        >
          <span data-testid="labeled-control-message">
            {{ $bct(message) }}
          </span>

          <RequiredIndicator v-if="mandatory" />
        </v-col>

        <template v-if="removable">
          <v-col
            class="d-flex justify-end"
            cols="4"
          >
            <v-btn
              @click="$emit('remove')"
              class="c-white"
              color="red"
              size="small"
            >
              <span>{{ $bct('Remove') }}</span>
            </v-btn>
          </v-col>
        </template>
      </template>

      <template v-if="description">
        <v-col
          class="c-light-black my-1"
          cols="12"
        >
          {{ $bct(description) }}
        </v-col>
      </template>

      <v-col
        cols="12"
        data-testid="labeled-control-input"
      >
        <slot />
      </v-col>
    </v-row>

    <v-divider
      v-if="dividedBottom"
      class="mt-4 mb-2"
    />
  </v-col>
</template>

<script setup>
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';
import useLabeledField from '@/shared/composables/useLabeledField';
import propsToRefs from '@/shared/utils/propsToRefs';

const $bct = inject('translator');

defineEmits(['remove', ...useLabeledField.emits]);

const props = defineProps({
  dividedBottom: {
    type: Boolean,
    default: false,
  },
  format: {
    type: String,
    default: null,
  },
  mandatory: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: null,
  },
  removable: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: null,
  },
  ...useLabeledField.props,
});

const { labelClass } = useLabeledField(...propsToRefs(props, useLabeledField.paramKeys));

const classes = computed(() => {
  // The date selector doesn't work at any narrower width then 300.
  if (props.type === 'string' && props.format === 'date') {
    return 'mnw-300';
  }
  return 'mnw-200';
});
</script>
